<template>
  <div class="m-0" v-if="isManeuverAnalysisRequest">
    <v-dialog fullscreen v-model="displayPlotDialog">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="displayPlotDialog = false">
            <span class="v-btn__content"
              ><i
                aria-hidden="true"
                class="v-icon notranslate material-icons theme--light"
                >close</i
              ></span
            >
          </v-btn>
          <v-toolbar-title>{{ displayedPlotTitle }} plot</v-toolbar-title>
        </v-toolbar>
        <div class="dialogContentContainer">
          <div id="fullScreenPlotDiv"></div>
        </div>
      </v-card>
    </v-dialog>
    <div class="text-xs-center" v-if="displayComputationWidget">
      <exo-mission-computation></exo-mission-computation>
    </div>
    <v-dialog v-if="displayError" v-model="dialog" class="text-center">
      <template v-slot:activator="{ on: dialog }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-col class="bug-btn-col">
              <v-btn large class="bug-button" v-on="{ ...dialog, ...tooltip }">
                <icon class="red--text" scale="1.5" name="user-injured" />
                <span class="red--text bug-btn-txt">Bug report</span>
              </v-btn>
            </v-col>
          </template>
          <span>Display bug report</span>
        </v-tooltip>
      </template>
      <error-log-display
        :root="_self"
        :computationLog="currentResultsLog"
      ></error-log-display>
    </v-dialog>
    <div v-if="displayResult & !displayError">
      <v-row>
        <v-col class="pb-3">
          <v-row no-gutters>
            <div class="d-inline-flex ml-3 justify-center align-center">
              <span class="headline grey--text">{{
                currentMission.name.toUpperCase()
              }}</span>
            </div>
            <v-spacer></v-spacer>
            <div
              class="mr-6"
              v-if="lastMeanOrbit != null && currentSpaceObject != null"
            >
              <v-dialog scrollable width="1050" v-model="redirectDialog">
                <ManeuverAnalysisToDataGenerationDialogue
                  :isOpenDialog.sync="redirectDialog"
                  :orbit="lastMeanOrbit"
                  :spaceObject="currentSpaceObject"
                  :usedPropellant="usedPropellant"
                  :remainingPropellant="remainingPropellant"
                  :propellantFieldType="propellantFieldType"
                ></ManeuverAnalysisToDataGenerationDialogue>
              </v-dialog>
              <v-btn
                color="#932a2a"
                v-if="lastMeanOrbit"
                @click="redirectDialog = true"
                >To data generation</v-btn
              >
            </div>
          </v-row>
        </v-col>
      </v-row>

      <v-divider class="mt-0"></v-divider>
      <div class="px-3 pt-3">
        <v-row class="px-3 pt-3">
          <v-col cols="3">
            <v-expansion-panels class="pt-3" multiple :value="expansion">
              <v-expansion-panel>
                <v-expansion-panel-header :style="'background: #5757FF'">
                  <v-row>
                    <icon
                      class="ml-6 mr-4"
                      color="white"
                      scale="1.5"
                      name="list"
                    />
                    <span
                      class="font-weight-bold mt-1 text-truncate white--text"
                      >Lifetime Report
                    </span>
                    <exo-help-dialog
                      :color="'white--text'"
                      :margin="'ma-0'"
                      title="Lifetime Report"
                    >
                      <tooltipLifeTimeReport />
                    </exo-help-dialog>
                  </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <DataPanel
                    :values="lifeTimeReportFields"
                    :categories="lifeTimeReportCategories"
                    :context="'CumulativeManeuverInformationReport'"
                  >
                  </DataPanel
                ></v-expansion-panel-content> </v-expansion-panel
            ></v-expansion-panels>
          </v-col>

          <v-col cols="9">
            <v-row>
              <v-col cols="12">
                <v-card outlined :style="'background: white-text'">
                  <v-card-title class="pa-0 mb-4 mt-3">
                    <icon
                      class="ml-6 mr-4"
                      scale="1.5"
                      color="white-text"
                      name="crosshairs"
                    /><span
                      class="font-weight-light ml-2 text-truncate white-text"
                      >Space Object
                    </span>
                    <exo-help-dialog
                      :color="'white-text'"
                      :margin="'ma-0'"
                      title="Space Object"
                    >
                      <tooltipSpaceObject />
                    </exo-help-dialog>
                  </v-card-title>
                  <v-card tile height="100%">
                    <v-row>
                      <v-col cols="4">
                        <v-card outlined>
                          <v-card flat height="100%">
                            <v-card-title class="pa-0">
                              <span
                                class="
                                  font-weight-light
                                  ml-2
                                  mt-1
                                  text-truncate
                                "
                                >Space Object
                              </span>
                            </v-card-title>
                            <div
                              class="px-5 mt-3"
                              v-for="(
                                value, field
                              ) in mandatorySpaceObjectFields.filteredSpaceObjectReport"
                              :key="field"
                            >
                              <v-row dense>
                                <v-col cols="8">
                                  {{ field }}
                                </v-col>
                                <v-col cols="4">
                                  {{ value }}
                                </v-col>
                              </v-row>
                            </div></v-card
                          >

                          <v-card flat height="100%">
                            <v-card-title class="pa-0">
                              <span
                                class="
                                  font-weight-light
                                  ml-2
                                  mt-1
                                  text-truncate
                                "
                                >Spacecraft
                              </span>
                            </v-card-title>
                            <div
                              class="px-5 mt-3"
                              v-for="(
                                value, field
                              ) in mandatorySpaceObjectFields.filteredSpacecraftReport"
                              :key="field"
                            >
                              <v-row dense>
                                <v-col cols="8">
                                  {{ field }}
                                </v-col>
                                <v-col cols="4">
                                  {{ value }}
                                </v-col>
                              </v-row>
                            </div></v-card
                          ></v-card
                        >
                      </v-col>

                      <v-col cols="4">
                        <v-card outlined>
                          <v-card-title class="pa-0">
                            <span
                              class="font-weight-light ml-2 mt-1 text-truncate"
                              >Thruster
                            </span>
                          </v-card-title>
                          <v-card tile height="100%"
                            ><div
                              class="px-5 mt-3"
                              v-for="(
                                value, field
                              ) in mandatorySpaceObjectFields.filteredThrusterReport"
                              :key="field"
                            >
                              <v-row dense>
                                <v-col cols="8">
                                  {{ field }}
                                </v-col>
                                <v-col cols="4">
                                  {{ value }}
                                </v-col>
                              </v-row>
                            </div>
                          </v-card></v-card
                        ></v-col
                      >
                      <v-col cols="4">
                        <v-card outlined>
                          <v-card-title class="pa-0">
                            <span
                              class="font-weight-light ml-2 mt-1 text-truncate"
                              >Spacecraft Geometry
                            </span>
                          </v-card-title>
                          <v-card tile height="100%">
                            <div
                              class="px-5 mt-3"
                              v-for="(
                                value, field
                              ) in mandatorySpaceObjectFields.filteredGeometryReport"
                              :key="field"
                            >
                              <v-row dense>
                                <v-col cols="8">
                                  {{ field }}
                                </v-col>
                                <v-col cols="4">
                                  {{ value }}
                                </v-col>
                              </v-row>
                            </div></v-card
                          ></v-card
                        >
                      </v-col>
                    </v-row>
                  </v-card></v-card
                ></v-col
              >
            </v-row>

            <v-row
              ><v-col cols="12">
                <v-card outlined :style="'background: #5757FF'">
                  <v-card-title class="pa-0 mb-4 mt-3"
                    ><icon
                      class="ml-6 mr-4"
                      color="white"
                      scale="1.5"
                      name="chart-line"
                    />
                    <span
                      class="font-weight-light ml-2 text-truncate white--text"
                      >Plots
                    </span>
                    <exo-help-dialog
                      :color="'white--text'"
                      :margin="'ma-0'"
                      title="Plots"
                    >
                      <tooltipPlots />
                    </exo-help-dialog>
                  </v-card-title>
                  <v-card tile height="100%">
                    <v-col
                      v-if="data"
                      style="display: flex; justify-content: space-evenly"
                    >
                      <div
                        v-for="graph in graphs"
                        :key="graph.label"
                        :id="graph.divId"
                        style="width: 33%; height: 300px"
                      ></div>
                    </v-col> </v-card></v-card></v-col
            ></v-row>
          </v-col>
        </v-row>
        <v-row class="px-3 pt-3" v-if="displayBallisticCoefficientPlot">
          <v-col cols="12">
            <v-expansion-panels multiple :value="expansion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-header :style="'background: #5757FF'">
                  <v-row>
                    <icon
                      class="ml-6 mr-4"
                      color="white"
                      scale="1.5"
                      name="satellite"
                    />
                    <span
                      class="font-weight-bold mt-1 text-truncate white--text"
                      >Space Object Report
                    </span>
                    <span class="ma-1 text-truncate white--text">
                      ({{ analysisType }} Analysis)
                    </span>

                    <exo-help-dialog
                      :color="'white--text'"
                      :margin="'ma-0'"
                      title="Space Object Report"
                    >
                      <tooltipSpaceObjectReport />
                    </exo-help-dialog>
                  </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-row
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <v-col>
                      <v-data-table
                        dense
                        :footer-props="{
                          'items-per-page-options': [5]
                        }"
                        :headers="spaceObjectReportHeaders"
                        :items="spaceObjectReports"
                        height="100%"
                      />
                    </v-col>
                    <v-col v-if="displayBallisticCoefficientPlot">
                      <div
                        class="pt-5"
                        :id="'balCoeffPlotDivDef'"
                        style="width: 100%; height: 227px"
                      ></div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content> </v-expansion-panel
            ></v-expansion-panels>
          </v-col>
        </v-row>
        <v-row class="px-3 pt-3">
          <v-col cols="12">
            <v-expansion-panels multiple :value="expansion">
              <v-expansion-panel>
                <v-expansion-panel-header :style="'background: #5757FF'">
                  <v-row>
                    <icon
                      class="ml-6 mr-4"
                      color="white"
                      scale="1.5"
                      name="satellite-dish"
                    />
                    <span
                      class="font-weight-bold mt-1 text-truncate white--text"
                      >Detected maneuvers
                    </span>
                    <exo-help-dialog
                      :color="'white--text'"
                      :margin="'ma-0'"
                      title="Detected maneuvers"
                    >
                      <tooltipDetectedManeuvers />
                    </exo-help-dialog>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    dense
                    class="mt-3"
                    :headers="maneuversHeaders"
                    :items="maneuvers"
                    :expanded.sync="detectedManeuverExpanded"
                    item-key="number"
                    show-expand
                    height="100%"
                  >
                    <template
                      v-slot:[`header.maneuverDetectionStatus`]="{ header }"
                    >
                      <v-row class="mb-n1">
                        <div>
                          {{ header.text }}
                        </div>

                        <exo-help-dialog
                          :color="'white--text'"
                          :margin="'mt-n2'"
                          title="Detection Status"
                          iconScale="0.75"
                        >
                          <tooltipDetectionStatus />
                        </exo-help-dialog>
                      </v-row>
                    </template>

                    <template v-slot:[`header.tags`]="{ header }">
                      <v-row class="mb-n1">
                        <v-select
                          multiple
                          clearable
                          class="filterHeaderSelect"
                          :class="
                            $vuetify.theme.dark
                              ? 'darkModePlaceholder'
                              : 'lightModePlaceholder'
                          "
                          small-chips
                          deletable-chips
                          single-line
                          solo
                          flat
                          hide-details
                          append-icon="list"
                          :items="availableTags"
                          v-model="selectedTagFilters"
                          placeholder="Maneuver tags"
                          persistent-placeholder
                        ></v-select>
                      </v-row>
                    </template>

                    <template v-slot:[`item.tags`]="{ item }">
                      <v-tooltip top v-for="tag in item.tags" :key="tag.name">
                        <template v-slot:activator="{ on }">
                          <v-chip
                            class="mt-1 mb-1 mr-2"
                            v-on="on"
                            :color="tag.color"
                            >{{ tag.name }}</v-chip
                          >
                        </template>
                        <span>{{ tag.message }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-row>
                          <v-col class="ml-2 mr-2"
                            ><DataPanel
                              :values="item.cumulativeInformationManeuverReport"
                              :categories="maneuversCategories"
                              :context="'CumulativeManeuverInformationReport'"
                            ></DataPanel
                          ></v-col>
                          <v-col class="ml-2 mr-2"
                            ><DataPanel
                              :values="item.initialMeanOrbit.orbit"
                              :categories="initialOrbitCategories"
                              :context="'OrbitInformation'"
                              :bisValues="
                                item.initialMeanOrbit.orbit.uncertainties
                              "
                            ></DataPanel
                            ><DataPanel
                              :values="item.finalMeanOrbit.orbit"
                              :categories="finalOrbitCategories"
                              :context="'OrbitInformation'"
                              :bisValues="
                                item.finalMeanOrbit.orbit.uncertainties
                              "
                            ></DataPanel
                          ></v-col>
                          <v-col
                            class="d-none d-xl-block"
                            style="display: flex; align-items: center"
                          >
                            <cesium-viewer
                              :tracesResults="item.tracesResults"
                              :loading="false"
                              :offline="true"
                              style="height: 90%"
                            />
                          </v-col>
                          <v-col class="ml-2 mr-2">
                            <v-row class="d-block d-xl-none">
                              <v-col style="display: flex; align-items: center">
                                <cesium-viewer
                                  :tracesResults="item.tracesResults"
                                  :loading="false"
                                  :offline="true"
                                  style="height: 280px"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <div class="text-h6 mb-1">Results error</div>
                              <exo-help-dialog
                                :color="'white--text'"
                                :margin="'ma-0'"
                                title="Results error"
                              >
                                <tooltipResultsError />
                              </exo-help-dialog>
                            </v-row>
                            <div
                              class="mt-n1 mb-n1"
                              v-for="(value, field) in item.errorData"
                              :key="field"
                            >
                              <v-row dense>
                                <v-col cols="8">
                                  {{ field }}
                                </v-col>
                                <v-col cols="4">
                                  {{ displayNdigits(value, 2) }}
                                </v-col>
                              </v-row>
                            </div>
                            <v-divider class="mb-3 mt-3" />
                            <div class="text-h6 mt-3 mb-1">Error comments</div>
                            <div class="mt-n1 mb-n1">
                              {{ item.errorComment }}
                            </div>
                          </v-col>
                        </v-row>
                      </td>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel></v-expansion-panels
            ></v-col
          >
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardComponents from '../../components/Dashboard/index.js'
import dataTools from '../../tools/data.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import errorMixin from '../../mixins/logHandler.js'
import plotInput from '../../mixins/plotInput.js'
import plotLayout from '../../mixins/plotLayout.js'
import plotData from '../../mixins/plotData.js'
import Plotly from 'plotly.js-dist'
import { setTimeout } from 'timers'
import tooltipLifeTimeReport from '../../components/Tooltips/Defense/tooltipLifeTimeReport'
import tooltipSpaceObjectReport from '../../components/Tooltips/Defense/tooltipSpaceObjectReport'
import tooltipSpaceObject from '../../components/Tooltips/Defense/tooltipSpaceObject'
import tooltipPlots from '../../components/Tooltips/Defense/tooltipPlots'
import tooltipDetectedManeuvers from '../../components/Tooltips/Defense/tooltipDetectedManeuvers'
import tooltipResultsError from '../../components/Tooltips/Defense/tooltipResultsError'
import tooltipDetectionStatus from '../../components/Tooltips/Defense/tooltipDetectionStatus'
import DataPanel from './DataPanel'
import AnalyticalOrbitViewer from '../AnalyticalModel/AnalyticalOrbitViewer'
import dashboardTools from '../../tools/dashboard'
import ManeuverAnalysisToDataGenerationDialogue from './ManeuverAnalysisToDataGenerationDialogue'

Vue.use(dashboardComponents)

export default {
  name: 'ManeuverAnalysisDashboard',
  mixins: [errorMixin, plotLayout, plotInput, plotData],
  components: {
    tooltipLifeTimeReport,
    tooltipSpaceObjectReport,
    tooltipSpaceObject,
    tooltipPlots,
    tooltipDetectedManeuvers,
    tooltipResultsError,
    tooltipDetectionStatus,
    DataPanel,
    'cesium-viewer': AnalyticalOrbitViewer,
    ManeuverAnalysisToDataGenerationDialogue
  },
  data() {
    let me = this
    return {
      selectedTagFilters: [],
      graphs: [
        {
          label: 'semi-major axis',
          prop: 'semiMajorAxis',
          divId: 'smaPlotDivDef',
          yType: 'distance',
          tickformat: '.7g',
          yAxisThreshold: 0.00002
        },
        {
          label: 'inclination',
          prop: 'inclination',
          divId: 'incPlotDivDef',
          yType: 'angle',
          tickformat: '.5g',
          yAxisThreshold: 0.5
        },
        {
          label: 'eccentricity',
          prop: 'eccentricity',
          divId: 'eccPlotDivDef',
          yType: 'coefficient',
          yAxisThreshold: 0.001
        }
      ],
      plotConfig: {
        responsive: true,
        modeBarButtonsToRemove: ['select2d', 'lasso2d'],
        modeBarButtonsToAdd: [
          {
            name: 'Full screen',
            icon: Plotly.Icons.pan,
            direction: 'up',
            click: async function (gd) {
              if (!me.displayPlotDialog) {
                const index = me.graphs.findIndex((object) => {
                  return object.divId === gd.id
                })
                me.displayPlotDialog = true
                await me.$nextTick()
                if (index != -1) {
                  me.displayedPlotTitle = 'Mean ' + me.graphs[index].label
                  me.drawGraph(me.graphs[index], true)
                } else {
                  me.displayedPlotTitle = 'Balistic Coefficient'
                  me.drawBallisticCoefficientGraph(true)
                }
              }
            }
          }
        ]
      },
      data: null,
      maneuverBarsVisibleInGraph: {},
      dialog: false,
      displayPlotDialog: false,
      displayedPlotTitle: '',
      expanded: [],
      detectedManeuverExpanded: [],
      expansion: [0],
      isDrawn: [],
      drawer: false,
      plotingAreaName: 'plotingAreaAnalysis',
      statsCardName: 'statsCard',
      type: 'ManeuverAnalysisResult',
      redirectDialog: false,
      spaceObjectReportHeaders: [
        { text: 'Start calculation date', value: 'startDate', align: 'center' },
        { text: 'End calculation date', value: 'endDate', align: 'center' },
        {
          text:
            'Ballistic coefficient' +
            this.getUnitLabelFromPath(
              ['ballisticCoefficientEstimate'],
              'SpaceObjectBallisticReport'
            ),
          value: 'ballisticCoefficient',
          align: 'center'
        },
        {
          text:
            'Relative uncertainty' +
            this.getUnitLabelFromPath(
              ['ballisticCoefficientRelativeUncertainty'],
              'SpaceObjectBallisticReport'
            ),
          value: 'relativeUncertainty',
          align: 'center'
        }
      ],
      maneuversHeaders: [
        { text: 'Maneuver number', value: 'number', align: 'center' },
        {
          text: 'Detection status',
          value: 'maneuverDetectionStatus',
          sortable: false
        },
        {
          text: 'Maneuver tags',
          value: 'tags',
          sortable: false,
          width: '15%',
          filter: (value) => {
            let tagFound = false
            value.forEach((v, _) => {
              if (this.selectedTagFilters.length == 0) {
                tagFound = true
              } else {
                this.selectedTagFilters.forEach((f, _) => {
                  if (f == v.name) {
                    tagFound = true
                  }
                })
              }
            })
            return tagFound
          }
        },
        {
          text: 'Detected from measurement date',
          value: 'initialDate',
          align: 'center'
        },
        { text: 'Until measurement date', value: 'finalDate', align: 'center' },
        {
          value: 'meanManeuverDutyCycle',
          align: 'center',
          text:
            'Duty cycle' +
            me.getUnitLabelFromPath(
              ['meanManeuverDutyCycle'],
              'CumulativeManeuverReport'
            )
        },
        { text: '', value: 'data-table-expand' }
      ],
      maneuversCategories: {
        'Orbital changes': {
          fields: [
            { fieldName: 'totalDeltaSma' },
            { fieldName: 'totalDeltaInc' },
            { fieldName: 'totalDeltaEcc' }
          ]
        },
        'Maneuvers changes': {
          fields: [
            { fieldName: 'totalDeltaV' },
            { fieldName: 'totalUsedPropellant' },
            { fieldName: 'totalBurnDuration' }
          ]
        },
        'Maneuver potential residuals': {
          fields: [
            { fieldName: 'remainingPotentialDeltaV' },
            { fieldName: 'remainingPotentialPropellant' }
          ]
        }
      },
      initialOrbitCategories: {
        'Start Orbit': {
          fields: [
            { fieldName: 'orbitDateTime' },
            { fieldName: 'semiMajorAxis' },
            { fieldName: 'inclination' },
            { fieldName: 'eccentricity' },
            { fieldName: 'perigeeArgument' },
            { fieldName: 'raan' },
            { fieldName: 'anomaly' }
          ],
          titleColor: 'rgb(8,236,236)'
        }
      },
      finalOrbitCategories: {
        'End Orbit': {
          fields: [
            { fieldName: 'orbitDateTime' },
            { fieldName: 'semiMajorAxis' },
            { fieldName: 'inclination' },
            { fieldName: 'eccentricity' },
            { fieldName: 'perigeeArgument' },
            { fieldName: 'raan' },
            { fieldName: 'anomaly' }
          ],
          titleColor: '#FF0000'
        }
      },
      lifeTimeReportCategories: {
        'Orbital changes': {
          fields: [
            { fieldName: 'totalDeltaSma' },
            { fieldName: 'totalDeltaInc' },
            { fieldName: 'totalDeltaEcc' }
          ]
        },
        'Maneuvers changes': {
          fields: [
            { fieldName: 'totalDeltaV' },
            { fieldName: 'totalUsedPropellant' }
          ]
        },
        'Maneuver potential residuals': {
          fields: [
            { fieldName: 'remainingPotentialDeltaV' },
            {
              fieldName: 'remainingPotentialPropellant',
              label: 'Remaining propellant'
            },
            {
              fieldName: 'remainingPotentialPropellantPercentage',
              label: 'Remaining propellant (%)',
              fieldType: ''
            }
          ]
        }
      }
    }
  },

  watch: {
    async data() {
      await this.$nextTick()
      if (this.data && !dashboardTools.displayError(this)) {
        this.graphs.forEach((graph) => this.drawGraph(graph))
        this.drawBallisticCoefficientGraph()
      }
    },
    async spaceObjectReports() {
      await this.$nextTick()
      if (this.displayBallisticCoefficientPlot) {
        this.drawBallisticCoefficientGraph()
      }
    },
    async currentResultsLog() {
      if (this.currentResultsLog) {
        this.updateData()
      }
    }
  },

  mounted() {
    this.updateData()
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog'
    }),
    displayBallisticCoefficientPlot() {
      return this.spaceObjectReports.length > 0 && !this.displayError
    },
    displayComputationWidget() {
      return this.computationNeeded || !this.resultsLoaded
    },
    displayResult() {
      return this.resultsLoaded && !this.computationNeeded
    },
    displayError() {
      return dashboardTools.displayError(this)
    },
    computationNeeded() {
      return (
        this.currentMission &&
        this.currentMission.computationRequested &&
        this.currentMission.computationLogId === ''
      )
    },
    resultsLoaded() {
      return (
        this.currentResultsLog != null &&
        this.currentResultsLog.results != null &&
        this.currentResultsLog.results.analysisResult != null
      )
    },
    resultAvailable() {
      return (
        this.resultsLoaded &&
        this.currentResultsLog.results ===
          Object(this.currentResultsLog.results)
      ) // check object, not array
    },
    ephemeridesAvailable() {
      return (
        this.resultAvailable &&
        this.currentResultsLog.results.analysisResult.ephemerides != null
      )
    },
    ephemeridesFilesAvailable() {
      return (
        this.resultAvailable &&
        this.currentResultsLog.results.analysisResult.ephemeridesFiles != null
      )
    },
    isEphemeridesFilesGenerated() {
      if (this.ephemeridesFilesAvailable) {
        return (
          Object.keys(
            this.currentResultsLog.results.analysisResult.ephemeridesFiles
          ).length > 0
        )
      }
      return false
    },

    analysisType() {
      return dataTools.convertEnum2Display(
        'SpaceObjectReport',
        ['analysisType'],
        this.currentResultsLog.results.analysisResult.spaceObjectReport
          .analysisType
      )
    },

    maneuvers() {
      let maneuvers =
        this.currentResultsLog.results.analysisResult.maneuverCumulativeReports
      let filteredManeuvers = []
      for (let i = 0; i < maneuvers.length; i++) {
        const maneuverReport = maneuvers[i]

        const number = i + 1
        const maneuverDetectionStatus = dataTools.convertEnum2Display(
          'CumulativeManeuverReport',
          ['maneuverDetectionStatus'],
          maneuverReport.maneuverDetectionStatus
        )
        const initialDate =
          maneuverReport.initialMeanOrbit.orbit.orbitDateTime.slice(0, 19)
        const finalDate =
          maneuverReport.finalMeanOrbit.orbit.orbitDateTime.slice(0, 19)
        const meanManeuverDutyCycle = dataTools.convertSi2Display(
          dataTools.getFieldTypeFromPath(
            ['meanManeuverDutyCycle'],
            'CumulativeManeuverReport'
          ),
          maneuverReport.meanManeuverDutyCycle
        )

        let errorData = {}
        let errorComment = ''
        for (let errorDisplayer of maneuverReport.maneuverErrorDisplayer) {
          errorData[`${errorDisplayer.errorName} (%)`] =
            errorDisplayer.errorValue
          if (errorDisplayer.errorError !== '') {
            errorComment = errorDisplayer.errorError
          }
        }

        let tracesResults = [[]]
        tracesResults[0].push({
          altitude: maneuverReport.initialMeanOrbit.orbit.altitude,
          inclination: maneuverReport.initialMeanOrbit.orbit.inclination,
          traces: [maneuverReport.initialOrbitTrace],
          label: 'Start orbit'
        })
        tracesResults[0].push({
          altitude: maneuverReport.finalMeanOrbit.orbit.altitude,
          inclination: maneuverReport.finalMeanOrbit.orbit.inclination,
          traces: [maneuverReport.finalOrbitTrace],
          label: 'End orbit'
        })

        let filteredManeuverReport = {
          ...maneuverReport,
          number,
          maneuverDetectionStatus,
          meanManeuverDutyCycle,
          initialDate,
          finalDate,
          errorData,
          errorComment,
          tracesResults
        }

        const initialOrbit = filteredManeuverReport.initialMeanOrbit.orbit
        const finalOrbit = filteredManeuverReport.finalMeanOrbit.orbit
        initialOrbit.uncertainties = {}
        finalOrbit.uncertainties = {}

        const uncertaintyParameters = {
          raan: 'raanAbsoluteUncertainty',
          eccentricity: 'eccentricityAbsoluteUncertainty',
          inclination: 'inclinationAbsoluteUncertainty',
          perigeeArgument: 'perigeeArgumentAbsoluteUncertainty',
          semiMajorAxis: 'semiMajorAxisAbsoluteUncertainty',
          anomaly: 'trueAnomalyAbsoluteUncertainty'
        }

        Object.keys(uncertaintyParameters).forEach((fieldName, _) => {
          initialOrbit.uncertainties[fieldName] =
            filteredManeuverReport.initialMeanOrbit[
              uncertaintyParameters[fieldName]
            ]
          finalOrbit.uncertainties[fieldName] =
            filteredManeuverReport.finalMeanOrbit[
              uncertaintyParameters[fieldName]
            ]
        })

        filteredManeuvers.push(filteredManeuverReport)
      }
      return filteredManeuvers
    },
    spaceObjectReports() {
      let spaceObjectReport =
        this.currentResultsLog?.results?.analysisResult?.spaceObjectReport
      if (spaceObjectReport == null) {
        return []
      }
      let lines = []
      for (const ballisticReport of spaceObjectReport.ballisticReports) {
        const context = 'SpaceObjectBallisticReport'

        const ballisticCoefficientType = dataTools.getFieldTypeFromPath(
          ['ballisticCoefficientEstimate'],
          context
        )
        const ballisticCoefficient = dataTools.convertSi2Display(
          ballisticCoefficientType,
          ballisticReport.ballisticCoefficientEstimate
        )

        const relativeUncertaintyType = dataTools.getFieldTypeFromPath(
          ['ballisticCoefficientRelativeUncertainty'],
          context
        )
        const relativeUncertainty = dataTools.convertSi2Display(
          relativeUncertaintyType,
          ballisticReport.ballisticCoefficientRelativeUncertainty
        )

        lines.push({
          ballisticCoefficient: dataTools.isNumber(ballisticCoefficient)
            ? ballisticCoefficient.toExponential(3)
            : 'NaN',
          relativeUncertainty: dataTools.isNumber(relativeUncertainty)
            ? dataTools.displayNdigits(relativeUncertainty, 0)
            : 'NaN',
          startDate: ballisticReport.startDate.substring(0, 19),
          endDate: ballisticReport.endDate.substring(0, 19)
        })
      }
      return lines
    },
    mandatorySpaceObjectFields() {
      const spaceObjectFields =
        this.currentResultsLog.results.analysisResult.spaceObject
      const spaceObjectThrusterFields = spaceObjectFields.spacecraft.thruster
      const spaceObjectGeometryFields =
        spaceObjectFields.spacecraft.spacecraftGeometry
      const spaceObjectSpacecraftFields = spaceObjectFields.spacecraft
      const filteredReport = {}

      const filteredGeometryReport = this.filterManeuverReport(
        spaceObjectGeometryFields,
        'SpacecraftGeometry'
      )

      const filteredThrusterReport = this.filterManeuverReport(
        spaceObjectThrusterFields,
        'PropulsionSystem'
      )
      const filteredSpaceObjectReport = this.filterManeuverReport(
        spaceObjectFields,
        'SpaceObject'
      )

      const filteredSpacecraftReport = this.filterManeuverReport(
        spaceObjectSpacecraftFields,
        'SpacecraftDefinition'
      )

      filteredReport['filteredGeometryReport'] = filteredGeometryReport
      filteredReport['filteredThrusterReport'] = filteredThrusterReport
      filteredReport['filteredSpaceObjectReport'] = filteredSpaceObjectReport
      filteredReport['filteredSpacecraftReport'] = filteredSpacecraftReport

      return filteredReport
    },

    lifeTimeReportFields() {
      // ADDS EXTRA FIELD TO REPORT CALCULATED FROM REMAINING AND USED PROPELLANT
      const ar = this.currentResultsLog.results.analysisResult
      const cmiReport = ar.cumulativeManeuverInformationReport
      const remaining = cmiReport.remainingPotentialPropellant
      const used = cmiReport.totalUsedPropellant
      const remainingRatio = remaining / (remaining + used)
      const remainingPercent = (remainingRatio * 100).toFixed(2)
      cmiReport.remainingPotentialPropellantPercentage = remainingPercent

      return this.currentResultsLog.results.analysisResult
        .cumulativeManeuverInformationReport
    },

    basePlotLayout() {
      return {
        plot_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        paper_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        font: { color: this.$vuetify.theme.dark ? 'white' : '#121212' },
        xaxis: {
          title: { text: 'Time (Days)' }
        },
        margin: { t: 0 },
        shapes: this.maneuverHighlight
      }
    },
    maneuverHighlight() {
      const shape = []
      for (let maneuver of this.maneuvers) {
        const rectangle = {
          type: 'rect',

          xref: 'x',
          x0: maneuver.initialDate,
          x1: maneuver.finalDate,

          yref: 'paper',
          y0: 0,
          y1: 1,

          fillcolor: '#737373',
          opacity: 0.3,
          line: {
            width: 0
          }
        }
        shape.push(rectangle)
      }
      return shape
    },
    maneuverLegend() {
      return {
        x: [null],
        y: [null],
        type: 'bar',
        marker: {
          color: '#737373',
          line: { color: 'transparent' }
        },
        opacity: 0.3,
        name: 'Detected maneuvers'
      }
    },

    availableTags() {
      let tags = []
      this.maneuvers.forEach((m, _) => {
        m.tags.forEach((t, _) => {
          if (!tags.some((e) => e.name === t.name).length) {
            tags.push({
              id: t.name,
              text: t.name
            })
          }
        })
      })
      return tags
    },

    lastMeanOrbit() {
      const orbits =
        this?.currentResultsLog?.results?.analysisResult?.analyzedMeanOrbits
      if (orbits != null && orbits.length > 0) {
        return orbits[orbits.length - 1]?.orbit
      } else {
        return null
      }
    },
    currentSpaceObject() {
      return this?.currentMission?.analysisRequest?.spaceObject
    },
    usedPropellant() {
      return this?.currentResultsLog?.results?.analysisResult
        ?.cumulativeManeuverInformationReport?.totalUsedPropellant
    },
    remainingPropellant() {
      return this?.currentResultsLog?.results?.analysisResult
        ?.cumulativeManeuverInformationReport?.remainingPotentialPropellant
    },
    propellantFieldType() {
      return dataTools.getFieldTypeFromPath(
        ['remainingPotentialPropellant'],
        'CumulativeManeuverInformationReport'
      )
    }
  },

  methods: {
    determineGraphRange(graph) {
      let min = null,
        max = null,
        diff = null,
        range = null

      // DETERMINE MIN AND MAX VALUES
      this.data.graphs[graph.label].y.forEach((yval, _) => {
        let val = parseFloat(dataTools.convertSi2gui(graph.yType, yval))
        if (min == null || val < min) {
          min = val
        }
        if (max == null || val > max) {
          max = val
        }
      })

      diff = max - min

      // IF DIFF IS BELOW THRESHOLD THEN INCREASE Y AXIS RANGE BOUNDARIES
      if (diff < graph.yAxisThreshold) {
        let boundaryIncrease = parseFloat(graph.yAxisThreshold - diff) / 2
        min -= boundaryIncrease
        max += boundaryIncrease

        // LIMIT MIN TO ZERO FOR ECC AND INC
        if (graph.prop == 'eccentricity' || graph.prop == 'inclination') {
          if (min < 0) {
            min = 0
            max = graph.yAxisThreshold
          }
        }

        range = [min, max]
      }

      return range
    },

    displayNdigits(valeur, digits) {
      return dataTools.displayNdigits(valeur, digits)
    },
    filterOrbitalChangesReport(report, context) {
      let filteredReport = {}
      const cumulativeReport = report.cumulativeInformationManeuverReport

      for (let field in cumulativeReport) {
        let fieldType = dataTools.getFieldTypeFromPath([field], context)
        let fieldValue = cumulativeReport[field]

        let convertToDisplay = dataTools.convertSi2Display(
          fieldType,
          fieldValue
        )

        filteredReport[field] = convertToDisplay
      }
      filteredReport['initialDate'] =
        report.initialMeanOrbit.orbit.orbitDateTime.slice(0, 24)
      filteredReport['finalDate'] =
        report.finalMeanOrbit.orbit.orbitDateTime.slice(0, 24)
      return filteredReport
    },

    filterManeuverReport(report, context, reportType) {
      let filteredReport = {}
      const excludedFieldsTypes = [
        'OrbitDefinition',
        'Initial Mean Orbit',
        'Final Mean Orbit'
      ]
      const excludedFieldsNames = [
        'Electrical efficiency',
        'Nominal power',
        'Standby power',
        'Warm-up power',
        'Warm-up duration',
        'Final propellant mass',
        'Final total mass',
        'Initial total mass',
        'Total impulse'
      ]
      const includedFieldsNames = [
        'NORAD ID',
        'Name',
        'Platform mass without thruster',
        'Specific impulse',
        'Nominal thrust',
        'Initial propellant mass',
        'Spherical cross section'
      ]
      if (reportType === 'maneuverReport') {
        report = report.cumulativeInformationManeuverReport
      }

      for (let field in report) {
        let fieldType = dataTools.getFieldTypeFromPath([field], context)
        let fieldLabel = ''
        let fieldValue = report[field]
        let isFieldDisplayed = true

        if (reportType === 'maneuverReport') {
          fieldLabel = field
        } else {
          fieldLabel = dataTools.getFieldLabelFromPath([field], context)
        }

        if (field === 'thrust') {
          fieldType = 'forceSI'
        }

        if (field === 'sphericalCrossSection') {
          fieldType = 'areaSI'
        }

        fieldValue =
          fieldType === 'date' && field === 'maneuverInitialDate'
            ? report.initialManeuverMeanOrbit.orbit.orbitDateTime.slice(0, 24)
            : fieldType === 'date' && field === 'maneuverFinalDate'
            ? report.finalManeuverMeanOrbit.orbit.orbitDateTime.slice(0, 24)
            : fieldValue

        let convertToDisplay = dataTools.convertSi2Display(
          fieldType,
          fieldValue
        )

        if (context !== 'SpaceObject') {
          excludedFieldsNames.push('Name')
        }

        if (
          (context === 'SpacecraftGeometry' ||
            context === 'SpaceObject' ||
            context === 'SpacecraftDefinition' ||
            context === 'PropulsionSystem') &&
          !includedFieldsNames.includes(fieldLabel)
        ) {
          isFieldDisplayed = false
        }

        convertToDisplay = convertToDisplay === '-0' ? '0' : convertToDisplay

        const fieldUnit = dataTools.getDefaultGuiUnit(fieldType)
        const fieldLabelDisplayed =
          fieldUnit !== '' ? `${fieldLabel} (${fieldUnit})` : fieldLabel

        if (
          !excludedFieldsTypes.includes(fieldType) &&
          !excludedFieldsNames.includes(fieldLabel) &&
          isFieldDisplayed
        ) {
          filteredReport[fieldLabelDisplayed] = convertToDisplay
        }
      }
      if (reportType === 'maneuverReport') {
        console.log(filteredReport)
      }
      return filteredReport
    },

    async updateData() {
      if (this.resultAvailable) {
        let data = {}
        let results = this.currentResultsLog.results.analysisResult
        data.graphs = this.getGraphDataFromResults(results)
        this.data = data
        this.error = null
      }
    },

    getGraphDataFromResults(results) {
      const graphsData = {}
      this.graphs.forEach((graph) => {
        const x = results.analyzedMeanOrbits.map(
          (orbitReport) => orbitReport.orbit.orbitDateTime
        )
        const y = results.analyzedMeanOrbits.map(
          (orbitReport) => orbitReport.orbit[graph.prop]
        )

        const errory = results.analyzedMeanOrbits.map(
          (orbitReport) => orbitReport[graph.prop + 'AbsoluteUncertainty']
        )
        graphsData[graph.label] = { x, y, errory }
      })
      return graphsData
    },

    spaceObjectBallisticCoefficient() {
      const spacecraft =
        this.currentResultsLog.results.analysisResult.spaceObject.spacecraft
      const dragCoefficient = spacecraft.dragCoefficient
      const sphericalCrossSection =
        spacecraft.spacecraftGeometry.sphericalCrossSection
      const totalMass =
        spacecraft.thruster.initialTotalMass + spacecraft.platformMass
      return dragCoefficient * (sphericalCrossSection / totalMass)
    },

    drawBallisticCoefficientGraph(inFullScreenDialog) {
      const divId = inFullScreenDialog
        ? 'fullScreenPlotDiv'
        : 'balCoeffPlotDivDef'
      const plotDiv = document.getElementById(divId)
      const plotLayout = {
        ...this.basePlotLayout,
        yaxis: {
          title: {
            text: `Balistic Coefficient`
          },
          tickformat: '.3g'
        },
        legend: {
          y: '0.5'
        }
      }
      const coeffTraces = []
      const reference_line_x = []
      const estimated_coeff_x = []
      const estimated_coeff_y = []
      const estimated_coeff_symbols = []
      this.spaceObjectReports.forEach((report) => {
        estimated_coeff_x.push(report.startDate, report.endDate, null)
        estimated_coeff_y.push(
          report.ballisticCoefficient,
          report.ballisticCoefficient,
          null
        )
        estimated_coeff_symbols.push(
          'triangle-right',
          'triangle-left',
          'circle'
        )
        reference_line_x.push(report.startDate, report.endDate)
      })
      coeffTraces.push({
        x: estimated_coeff_x,
        y: estimated_coeff_y,
        type: 'scatter',
        hovertemplate: 'Ballistic Coefficient: %{y:.3g}',
        marker: {
          size: 10,
          symbol: estimated_coeff_symbols,
          color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
        },
        name: 'Estimation from measurements'
      })
      coeffTraces.push({
        x: reference_line_x,
        y: reference_line_x.map(() => this.spaceObjectBallisticCoefficient()),
        mode: 'line',
        hovertemplate: 'Ballistic Coefficient: %{y:.3g}',
        marker: {
          size: 1,
          opacity: 0,
          color: 'red'
        },
        name: 'Estimation from input space object'
      })
      coeffTraces.push(this.maneuverLegend)
      Plotly.newPlot(plotDiv, coeffTraces, plotLayout, this.plotConfig)

      this.initManeuverLegendToggle(divId, 2)
    },

    drawGraph(graph, inFullScreenDialog) {
      const divId = inFullScreenDialog ? 'fullScreenPlotDiv' : graph.divId
      const plotDiv = document.getElementById(divId)
      const unit = dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(graph.yType)
      )
      const plotLayout = {
        ...this.basePlotLayout,
        yaxis: {
          title: {
            text: `Mean ${graph.label} ${unit ? '(' + unit + ')' : ''}`
          },
          tickformat: graph.tickformat ? graph.tickformat : '.3g'
        },
        legend: {
          orientation: 'h',
          xanchor: 'center',
          x: '0.4',
          y: '-0.3'
        }
      }

      let range = this.determineGraphRange(graph)
      if (range) {
        plotLayout.yaxis.range = range
      }

      Plotly.newPlot(
        plotDiv,
        [
          {
            x: this.data.graphs[graph.label].x,
            y: this.data.graphs[graph.label].y.map((y) =>
              dataTools.convertSi2gui(graph.yType, y)
            ),
            marker: {
              color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
            },
            name: '',
            error_y: {
              color: '#e34461',
              thickness: 0.5,
              type: 'data',
              array: this.data.graphs[graph.label].errory.map((errory) =>
                dataTools.convertSi2gui(graph.yType, errory)
              ),
              visible: true
            },
            type: 'scatter',
            showlegend: false
          },
          this.maneuverLegend
        ],
        plotLayout,
        this.plotConfig
      )

      this.initManeuverLegendToggle(divId)
    },

    initManeuverLegendToggle(divId, curveIndex) {
      let me = this
      const plotDiv = document.getElementById(divId)
      let maneuverBarsvisibility = this.maneuverBarsVisibleInGraph[divId]
      maneuverBarsvisibility = true
      plotDiv.on('plotly_legendclick', function (data) {
        if (!curveIndex || data.curveNumber == curveIndex) {
          let shapes = []
          if (!maneuverBarsvisibility) {
            maneuverBarsvisibility = true
            shapes = me.basePlotLayout.shapes
          } else {
            maneuverBarsvisibility = false
          }
          Plotly.relayout(plotDiv, { shapes: shapes })
          return true
        }
      })
    },

    addDefaultAxis(axisList, condition, name) {
      if (condition) {
        let parameter = this.buidDefaultPlotParameter()
        parameter.value = name
        this.treeUpdated(parameter, 'parameter')
        axisList.push(parameter)
      }
    },

    getUnitLabelFromPath(fieldPath, context) {
      const fieldType = dataTools.getFieldTypeFromPath(fieldPath, context, null)
      return dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
    },

    buildPath(path) {
      if (!this.resultAvailable) {
        return
      }
      let field = this.currentResultsLog.results.analysisResult
      for (let i = 0; i < path.length; i++) {
        field = field[path[i]]
      }
      return field
    },

    computeResultToDisplay(fieldPath) {
      let fieldType = dataTools.getFieldTypeFromPath(fieldPath, this.type, null)
      return dataTools
        .convertSi2Display(fieldType, this.buildPath(fieldPath))
        .toString()
    },

    getMissionItem(mission) {
      if (mission && mission.constructor === Array) {
        return mission[0]
      } else {
        return mission
      }
    },

    // TODO MFI most of these methos should be deleted
    isMissionType(mission, type) {
      return (
        this.getMissionItem(mission) &&
        this.getMissionItem(mission).type === type
      )
    },

    isManeuverAnalysisRequest(mission) {
      return mission.typeName === 'ManeuverCatalogueAnalysisRequest'
    },

    getCurrentAPI() {
      if (this.currentMission) {
        return this.getAPI(this.currentMission.typeName + 's')
      }
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');

.dialogContentContainer {
  padding: 30px;
  height: calc(100vh - 70px);
}

#fullScreenPlotDiv {
  width: 100%;
  height: 100%;
}

.bug-btn-txt {
  margin-left: 12px;
}

.bug-btn-col {
  text-align: center;
}

.filterHeaderSelect {
  min-height: 2px;
  font-size: 12px !important;
  margin-bottom: 4px !important;
}
</style>
<style>
.darkModePlaceholder input::placeholder {
  color: #ffffffb3 !important;
}
.lightModePlaceholder input::placeholder {
  color: #00000099 !important;
}
</style>
